"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicRenderConfigId = void 0;
var DynamicRenderConfigId;
(function (DynamicRenderConfigId) {
    DynamicRenderConfigId["carYear"] = "car-year";
    DynamicRenderConfigId["insuredValue"] = "insured-value";
    DynamicRenderConfigId["allowedProducts"] = "allowed-products";
    DynamicRenderConfigId["allowedBrands"] = "allowed-brands";
    DynamicRenderConfigId["allowedModels"] = "allowed-models";
    DynamicRenderConfigId["userInterface"] = "user-interface";
})(DynamicRenderConfigId = exports.DynamicRenderConfigId || (exports.DynamicRenderConfigId = {}));
//# sourceMappingURL=DynamicRenderConfig.js.map